var _g, _g2, _g3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 440,
    viewBox: "0 0 444 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_663_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.973 100.298L212.53 18L16.0758 100.298V195.729C16.0758 250.887 11.252 308.671 78.5498 396.222C114.08 442.446 182.673 470.349 212.53 478.52C235.111 475.602 292.918 455.057 343.5 396.222C405.973 323.555 406.224 238.046 405.973 195.729V100.298Z",
    fill: "url(#paint0_linear_663_894)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_663_894)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 352.437,
    width: 150,
    height: 46.5517,
    fill: "url(#pattern0)",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_i_663_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0391 260.462L113.316 172.793L148.07 260.462H77.0391Z",
    stroke: "#1E1E1E",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.855 260.462L309.132 172.793L343.887 260.462H272.855Z",
    stroke: "#1E1E1E",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.734 325.73H141.99V315.812C182.945 315.812 201.503 290.428 205.662 277.736H215.901C227.932 307.429 260.802 315.492 275.734 315.812V325.73Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.102,
    cy: 107.841,
    r: 11.8386,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.329,
    cy: 170.232,
    r: 10.2387,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.874,
    cy: 170.232,
    r: 10.2387,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.264,
    y: 117.112,
    width: 23.6771,
    height: 50.5538,
    rx: 11.8386,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.264,
    y: 264.943,
    width: 23.6771,
    height: 50.5538,
    rx: 11.8386,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.133,
    y: 315.49,
    width: 13.4384,
    height: 158.701,
    rx: 6.71918,
    transform: "rotate(90 290.133 315.49)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.383,
    y: 163.188,
    width: 13.4384,
    height: 106.867,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.678 172.466C117.037 171.933 135.083 168.691 148.393 159.988C165.031 149.109 177.189 137.271 211.105 137.271C245.021 137.271 258.139 151.349 273.818 159.988C290.775 169.332 303.681 171.293 310.613 172.466",
    stroke: "#1E1E1E",
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.102,
    cy: 177.591,
    r: 11.8386,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7178 254.057C68.7178 262.373 73.5383 270.349 82.119 276.229C90.6996 282.109 102.337 285.413 114.472 285.413C126.607 285.413 138.245 282.11 146.825 276.229C155.406 270.349 160.227 262.373 160.227 254.057L114.472 254.057L68.7178 254.057Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.536 254.057C264.536 262.373 269.357 270.349 277.937 276.229C286.518 282.109 298.156 285.413 310.291 285.413C322.425 285.413 334.063 282.11 342.644 276.229C351.224 270.349 356.045 262.373 356.045 254.057L310.291 254.057L264.536 254.057Z",
    fill: "#1E1E1E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.9189 396.222C114.45 442.446 183.042 470.349 212.899 478.52V18L16.445 100.298V195.729C16.445 250.887 11.6212 308.671 78.9189 396.222Z",
    fill: "url(#paint1_linear_663_894)",
    fillOpacity: 0.06
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_663_894",
    x: 0,
    y: 0,
    width: 444,
    height: 514.521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_663_894"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_663_894",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_663_894",
    x: 136,
    y: 352.437,
    width: 150,
    height: 50.5518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_663_894"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_663_894",
    transform: "matrix(0.00355872 0 0 0.011467 0 -0.00454738)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_663_894",
    x: 68.7188,
    y: 96.002,
    width: 291.326,
    height: 236.927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_663_894"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_663_894",
    x1: -6.56676,
    y1: 18,
    x2: 362.54,
    y2: 409.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_663_894",
    x1: 0.875989,
    y1: 54.863,
    x2: 310.739,
    y2: 491.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_663_894",
    width: 281,
    height: 88,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARkAAABYCAYAAADBY4NqAAAACXBIWXMAAAsSAAALEgHS3X78AAAFgklEQVR4nO3d8XHbNhTHcbye/482qDeoN4gyQZsNvEG8QewJ6hGcDbJB5A2kDegNrAmQgwOoKENKtIRHgMD3c+ezzpfYpEj9AILggxhjbowxjyatJ2vt03t/o4jMvi0i8ujfg2SstevE+1CMhO/X6HFJeR7UfCw0aHwerowxK2PMx8Tbuznz/+XYlhuFvzmZiKxSH9TEttba1+hXpnq/jh0XjfPgqAUch0t01tpu4v9P/nm4SrorOIc7qD8Kfuc+XdBoLEnpx+ESD8aY+1x//I9cfxhAGwgZAKoIGQCqigmZygfegGbNMvArIuE24rX/csLPXLB84BQE6qQVMrcicmuM+ZPzBmibVsgQLgDeMPALQBUhA0BVUzN+owHoeNCZO1qAohZC5k5EvhawHUCTWrhc4vY4kBFjMgBUETIAVBEyAFRRT6YeL644kcLevE74N8AoQqYerpxltsJEFXBh+lzAbrgHhf8qYDuSIWSAX7WAt9H8qWz8XK6qKvQxJgNAVSk9mTCeUF1XEWiddsjsXbV7/3rrr3tf45/FlfBr7CoCrdMKmQcGIQEYxmQAaCNkAKjiFjaKERWTp/xGRQgZ5LIWkbAy5TUlW+s1e8gMrFwQL4VCC9aObOuPY15aIeNaqftoBiUtFdAorZD5SEsFDOstZBi/vq6xN8+YDJCAiMQLF9748Oi/brLhbSFkwiMLYcZxF76stZ0ffKTXhd9E44cmuvTv90J4DOaEFkKGEgg4SURccDyybHJ6XC4Bv6zo0epgxi8AVYQMAFWEDABVhAwAVYQMAFXcXUpHa0kSYNEImdOGSoiGCX2uyv3mgt8NVK/2kHme0LvYTqk/DOA8Sw2Z+NIk9CQOQeHX0JnEWns39d/2HmwLz6T0f/bBWivJ9hRYuBJDJqzi91vvQvPSZKDOjaFUBXC5OUNmN3BJEkLj7WHFHMeTByQBXSlCZj8UGgyMArM4tbZZtgY8OBUy4dKlGxoDYWAUCQw1Um6c60vjb27o+ZulN95XfqMfzh04nWJgvOMpd7oiu9EFAP35UmvIDDXcap+9Elz5D/tZ9VZ8DY6hOyyrE4Olm7knro1s65ri5VD0zTWoJVyy5HRyTMa3KuveLdtiqoH1yh6GHlOR24rmuHBpfkxyysCv++B+nWFb/mdkTkocKNwRAhYg1zyZG5G3+Wpjay9R/hCoRK6Q+ZcTCGgDpR4AqCJkAKgiZACoImQAqKJoFU6KZmyvoykEqIw/zqvUe0XIoB8i8XfmIlUgdxkTQqZy0aTG/ndDiCzbUmogETL1cBMc73thwiMVC1RbATVCph5/+y8UqtXqiy2FzFhtnEdafCi5FZHb1ku31hAyQ2U9D0uXnHrEXkQovAUtzdeFNoWHzNCKBKEXUmVxH6BGuUJmF/U8ZluRIOiVkUg+LwDAf3KFzF3qMIkG1Uw0mBa/5m4LkEGxl0tRuUwT3ZIdek3tGaBguULmn5HbeSyiBlQmV8i0vtwF0AyewgagipABoIqQAaCKkAGgipABoIqQAaCKUg9AW/bRg8Rh1v3hgWK/dnfSYmaEDMb0ny8LD6dSGqNsoaRJ/7hNeqjYr+yaFCHTpqHW7NCqWWtHy19QGiOrseAvuioBIVOnl+gE7OITkxIZxdr1g2POygSaCJll6neJD9+P9UKQzUs/7GsJkCkImfLsh8LDLP+E3Pn92PowrOXD1Q8QM/XSsxWETH7uxPw0pVTogpQQKLvoQ3+uo3diKjpeKYXQ3YTjT8hk5ls6eiiXeY62oTtzG9wH4zMB8i4v0fu+Geu5TQmZ6q8Z8S5uHsX3TIGyj07ozm9DkoFsHyoEy7jQmHTHAmWIWGvL2AXA8wXNvsctpD+pCQFlIuLeb1d5Mk3v1BjzE/u0+WeYjh40AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImage);
export default __webpack_public_path__ + "static/media/LogoImage.724d32432843a2456a18a2a665558585.svg";
export { ForwardRef as ReactComponent };